var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e;
import UAParser from "ua-parser-js";
const parser = new UAParser();
const result = parser.getResult();
export var Browsers;
(function (Browsers) {
    Browsers[Browsers["Chromium"] = 0] = "Chromium";
    Browsers[Browsers["Firefox"] = 1] = "Firefox";
    Browsers[Browsers["Safari"] = 2] = "Safari";
})(Browsers || (Browsers = {}));
export class Device {
    static get global() {
        try {
            return globalThis;
        }
        catch (_a) {
            return window;
        }
    }
    static hasAcceptedMediaConstaints() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.tryPermissions()) || (yield this.tryEnumerateDevices());
        });
    }
    static checkMediaDevices() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const devices = yield navigator.mediaDevices.enumerateDevices();
                return {
                    audio: devices.some((d) => d.kind === "audioinput"),
                    video: devices.some((d) => d.kind === "videoinput"),
                    speaker: devices.some((d) => d.kind === "audiooutput"),
                };
            }
            catch (_a) {
                return null;
            }
        });
    }
    static tryPermissions() {
        return __awaiter(this, void 0, void 0, function* () {
            // safari doesn't support 'permissions'
            if (!("permissions" in navigator)) {
                return false;
            }
            try {
                const name = "camera";
                // eslint-disable-next-line compat/compat
                const result = yield navigator.permissions.query({ name });
                return result.state === "granted";
            }
            catch (_a) {
                // firefox doesn't support 'camera' and 'microphone'
                return false;
            }
        });
    }
    static tryEnumerateDevices() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!("mediaDevices" in navigator) ||
                !("enumerateDevices" in navigator.mediaDevices)) {
                return false;
            }
            try {
                const devices = yield navigator.mediaDevices.enumerateDevices();
                return devices.filter((d) => d.label !== "").length > 0;
            }
            catch (_a) {
                return false;
            }
        });
    }
}
Device.info = result;
Device.isFirefox = result.engine.name === "Gecko";
Device.isChromium = result.engine.name === "Blink";
Device.isSafari = (_b = (_a = result.browser.name) === null || _a === void 0 ? void 0 : _a.endsWith) === null || _b === void 0 ? void 0 : _b.call(_a, "Safari");
Device.browser = (() => {
    if (Device.isFirefox) {
        return Browsers.Firefox;
    }
    else if (Device.isChromium) {
        return Browsers.Chromium;
    }
    else if (Device.isSafari) {
        return Browsers.Safari;
    }
})();
Device.isMobile = result.device.type === "mobile" || result.device.type === "tablet";
Device.isiOS = result.os.name === "iOS";
Device.isAndroid = result.os.name === "Android";
Device.isIphone = result.device.model === "iPhone";
Device.isIFrame = (() => {
    try {
        return Device.global.self !== Device.global.top;
    }
    catch (ex) {
        return true;
    }
})();
Device.isElectron = /Electron/i.test(navigator.userAgent);
Device.isMutationObserverSupported = "MutationObserver" in Device.global;
Device.isWebRTCSupported = "RTCPeerConnection" in Device.global &&
    !!RTCPeerConnection.prototype.addTransceiver;
Device.isWasmSupported = "WebAssembly" in Device.global &&
    WebAssembly.validate(Uint32Array.of(0x6d736100, 1).buffer);
Device.isWasmSimdSupported = "WebAssembly" in Device.global &&
    WebAssembly.validate(Uint32Array.of(0x6d736100, 1, 1610679297, 33751040, 84344833, 6357249, 17369600, 4259847, 186257917, 1845758464, 40239360, 259).buffer);
Device.is2DCanvasSupported = !!((_d = (_c = Device.global.document) === null || _c === void 0 ? void 0 : _c.createElement("canvas").getContext("2d")) === null || _d === void 0 ? void 0 : _d.filter);
Device.isWebglSupported = "WebGLRenderingContext" in Device.global &&
    !!((_e = Device.global.document) === null || _e === void 0 ? void 0 : _e.createElement("canvas").getContext("webgl"));
Device.isWebAudioSupported = "AudioContext" in Device.global && "AudioWorkletNode" in Device.global;
Device.isSpeakerSelectionSupported = (() => {
    try {
        return HTMLAudioElement.prototype.setSinkId instanceof Function;
    }
    catch (_a) {
        return false;
    }
})();
//# sourceMappingURL=device.js.map